import { RunSchema } from '@/types/schema';
import { appGraphIndexPath } from '@/utils/constants';

export function getGraphUrlFromRun(
  organizationId: string | null,
  run: RunSchema | null | undefined
): string | null {
  const metadata = run?.extra?.metadata;
  if (
    organizationId == null ||
    metadata == null ||
    typeof metadata !== 'object'
  )
    return null;

  const hostProjectId =
    metadata?.['LANGSMITH_HOST_PROJECT_ID'] ??
    metadata?.['langsmith_host_project_id'];
  const threadId = metadata.thread_id;

  const query = new URLSearchParams();
  query.set('organizationId', organizationId);

  if (hostProjectId) {
    query.set('hostProjectId', hostProjectId);
    if (threadId) return `/${appGraphIndexPath}/thread/${threadId}?${query}`;
    return `/${appGraphIndexPath}/thread?${query}`;
  }

  const baseUrl =
    metadata?.['LANGGRAPH_API_URL'] ?? metadata?.['langgraph_api_url'];

  if (baseUrl) {
    query.set('baseUrl', baseUrl);
    if (threadId) return `/${appGraphIndexPath}/thread/${threadId}?${query}`;
    return `/${appGraphIndexPath}/thread?${query}`;
  }

  return null;
}
